import React, { useState } from 'react'
import Dashboardnavbarcopy from '../../layout/Dashboardnavbar';
import { ClientBasis, InvoiceBasis, MonthlyBasis, ProjectBasis } from './MonthlyBasis';


const Report = () => {

    const [toggleState, setToggleState] = useState('1');

    return (
        <>
            <div>
                <Dashboardnavbarcopy name={'Analytics'} url="Analytics" />
                {/* <div className="bloc-tabss  wfm-margin">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Monthly Basis
                    </button>


                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Project Basis
                    </button>

                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Client Basis
                    </button>


                    <button
                        className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(4)}
                    >
                        Invoice Basis
                    </button>




                </div> */}
                <div className="content-tabs">

                    {toggleState === '1' ? (

                        <MonthlyBasis value={toggleState} onChange={setToggleState} />
                    ) : null}

                    {toggleState === '2' ? (

                        <ProjectBasis value={toggleState} onChange={setToggleState} />
                    ) : null}
                    {toggleState === '3' ? (

                        <ClientBasis value={toggleState} onChange={setToggleState} />
                    ) : null}
                    {toggleState === '4' ? (

                        <InvoiceBasis value={toggleState} onChange={setToggleState} />
                    ) : null}







                </div>
            </div>

        </>
    )
}

export default Report;
